module.exports = __webpack_public_path__ + "static/media/mexican-laugh.99c57998.mp3";